<div fxLayout="column" fxLayoutAlign="start center">
  <tup-mat-content-wrapper class="main-content" position="first">
      <div fxLayout="row" fxLayoutAlign="fill center">
        <mat-nav-list fxLayout="row" class="underlined">
        <mat-list-item routerLink="/dash/api-tutorial/index" >
            <a>Index</a>
        </mat-list-item>
        <mat-list-item routerLink="/dash/api-tutorial/auth">
            <a>Authentication</a>
        </mat-list-item>
        <mat-list-item routerLink="/dash/api-tutorial/codebook">
            <a>Codebook</a>
        </mat-list-item>
        <mat-list-item routerLink="/dash/api-tutorial/engine">
            <a>Engine</a>
        </mat-list-item>
        </mat-nav-list>
    </div>
    <div class="markdown-content">
      <markdown
        [src]=source
        (error)="onMarkdownError($event)">
      </markdown>
    </div>
    </tup-mat-content-wrapper>
</div>
